import { HTMLAttributes } from 'react'
import {
  FlexboxProps,
  GridProps,
  LayoutProps,
  MarginProps,
  PositionProps,
} from 'styled-system'

import { GapProps, TestIdProps } from 'designSystem/types/propTypes'

import { COLOR } from 'designSystem/foundations/constants/color'
import { SIZE } from 'designSystem/foundations/constants/size'

import INTERNALxDiv from '../internal/elements/INTERNALxDiv'

type PaddingSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl'

type BaseProps = HTMLAttributes<HTMLDivElement> &
  FlexboxProps &
  GapProps &
  GridProps &
  LayoutProps &
  MarginProps &
  PositionProps &
  TestIdProps

type Props = {
  backgroundColor?: string
  borderColor?: string
  paddingSize?: PaddingSize
  showBorder?: boolean
} & BaseProps

export default function PDSSubCard({
  backgroundColor = COLOR.content,
  borderColor = COLOR.content_border,
  paddingSize = 'md',
  showBorder = true,
  testId,
  ...props
}: Props) {
  const padding = SUB_CARD_PADDING[paddingSize] ?? SUB_CARD_PADDING.md
  const border = showBorder ? `1.6px solid ${borderColor}` : 'none'

  return (
    <INTERNALxDiv
      {...props}
      backgroundColor={backgroundColor}
      border={border}
      borderRadius={SIZE.s8}
      boxShadow="none"
      padding={padding}
      testId={testId}
    />
  )
}

const SUB_CARD_PADDING = {
  xs: SIZE.s8,
  sm: SIZE.s12,
  md: SIZE.s16,
  lg: SIZE.s20,
  xl: SIZE.s24,
}
